'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _episodechangereport = require('./episodechangereport.component');

var _episodechangereport2 = _interopRequireDefault(_episodechangereport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var episodechangereportModule = _angular2.default.module('episodechangereport', [_angularUiRouter2.default]).component('episodechangereport', _episodechangereport2.default);

exports.default = episodechangereportModule;


// WEBPACK FOOTER //
// ./client/app/common/reports/episodechangereport/episodechangereport.js